import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { DataHandler } from 'C4';

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
    };
  }

  componentWillMount() {
    this.setBackgroundImage();
  }

  // componentDidUpdate() {
  //   this.setBackgroundImage();
  // }

  setBackgroundImage() {
    // DataHandler.matchAppId()
    //   .then(appId => this.setState({ image: `https://front.travpromobile.com/${appId}/bg.jpg` }));

    const { pathname } = window.location;

    if (pathname.includes('/retain')) {
      this.setState({ image: 'https://front.travpromobile.com/712/retain_bg.jpg' });
    } else if (pathname.includes('/promote')) {
      this.setState({ image: 'https://front.travpromobile.com/712/promote_bg.jpg' });
    } else if (pathname.includes('/sell')) {
      // TODO: have to add the correct bg image for sell
      this.setState({ image: 'https://front.travpromobile.com/712/sell-bg-2.jpg' });
    } else if (pathname.includes('/showcases')) {
      this.setState({ image: 'https://front.travpromobile.com/712/showcases_bg.jpg' });
    } else if (pathname.includes('training/chapter/2339') || pathname.includes('ret/chapter/2339')) {
      this.setState({ image: 'https://front.travpromobile.com/712/why-us_bg.jpg' });
    } else if (pathname.includes('training/chapter/2550') || pathname.includes('ret/chapter/2550')) {
      this.setState({ image: 'https://front.travpromobile.com/712/the-team_bg.jpg' });
    } else if (pathname.includes('training/chapter/2340') || pathname.includes('ret/chapter/2340')) {
      this.setState({ image: 'https://front.travpromobile.com/712/the-fleet_bg.jpg' });
    } else if (pathname.includes('training/chapter/2462') || pathname.includes('ret/chapter/2462')) {
      this.setState({ image: 'https://front.travpromobile.com/712/polar-regions_bg.jpg' });
    } else if (pathname.includes('training/chapter/2551') || pathname.includes('ret/chapter/2551')) {
      this.setState({ image: 'https://front.travpromobile.com/712/americas-asia-pacific_bg.jpg' });
    } else if (pathname.includes('training/chapter/2552') || pathname.includes('ret/chapter/2552')) {
      this.setState({ image: 'https://front.travpromobile.com/712/special-interest_bg.jpg' });
    } else {
      this.setState({ image: 'https://front.travpromobile.com/712/bg.jpg' });
    }
  }

  render() {
    const { image } = this.state;
    const { blur, darken } = this.props;

    return (
      <div>
        {image &&
          <div
            style={{ backgroundImage: `url("${image}")` }}
            className={`backgroundImage ${blur && 'blur'} ${darken && 'darken'}`}
          />}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
};
